module.exports = __webpack_public_path__ + "static/media/next-btn.8c6adc2e.svg";